module.exports = __webpack_public_path__ + "static/media/punch.692bb0aa.mp3";